import { trackEvent } from './mixpanel';

export const trackPageView = (pathname: string): void => {
  trackEvent('Page View', {
    pathname,
  });
};
